// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_b7-0";
export var orangeButton = "_b7-1";